import { Route } from '@angular/router';
import { BankComponent } from './components/bank/bank-component';

export const appRoutes: Route[] = [
  {
    path: ':lang',
    component: BankComponent,
  },
  { path: '', redirectTo: '/en', pathMatch: 'full' },
  { path: '**', redirectTo: '/en' }
];
